import { OnBoarding } from "@components/index";
import { useAuth } from "@hooks/useAuth";
import { Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "~/Services";
import styles from "../Auth.module.scss";
import { SignInWithAzureAD } from "./SignInWithAzureAD";

const { Title, Text } = Typography;

export const Login = () => {
  const navigate = useNavigate();
  const { isLoading, user } = useAuth();
  const { state }: any = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if ((state && state.sessionExpired) || (window.history.state && window.history.state.sessionExpired)) {
      setOpen(true);
    }
  }, [state]);

  const handleModal = () => {
    setOpen(false);
    window.history.replaceState({}, document.title);
  };

  const onLogin = async (data: any) => {
    post("userprofile/login", data).then((res: any) => {
      if (res.response.data) {
        localStorage.setItem("userEmail", data.emailAddress);
        navigate("/auth/verify-otp");
      }
    });
  };

  return (
    <OnBoarding>
      <Row>
        <Col span={18}>
          <Title
            level={2}
            // className={styles.textCenter}
          >
            Sign In
          </Title>
          <Typography.Text>Welcome back! Please enter your details</Typography.Text>
          <Col
            className={styles.textCenter}
            span={27}
            style={{ padding: `${styles.whitespace2} 0px`, color: styles.gray }}
          ></Col>
          <Col span={27}></Col>
        </Col>
      </Row>
      <SignInWithAzureAD />
    </OnBoarding>
  );
};
